import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, MapPinIcon } from 'lucide-react';
import { RideCard } from '../components/RideCard';
import { Button } from '../components/Button';
import { MapView } from '../components/MapView';
import { useApp } from '../context/AppContext';
export const RideOptions: React.FC = () => {
  const navigate = useNavigate();
  const {
    currentRide,
    setCurrentRide,
    rideOptions,
    selectedRideOption,
    setSelectedRideOption,
    getCurrency
  } = useApp();
  const currency = getCurrency(currentRide.pickup, currentRide.dropoff);
  const handleSelectRide = (id: string) => {
    setSelectedRideOption(id);
    const selected = rideOptions.find(option => option.id === id);
    if (selected) {
      setCurrentRide({
        ...currentRide,
        type: selected.type,
        price: selected.price,
        currency
      });
    }
  };
  const handleContinue = () => {
    if (selectedRideOption) {
      navigate('/confirmation');
    }
  };
  return <div className="min-h-screen bg-background" data-id="element-467">
      <div className="relative" data-id="element-468">
        <MapView className="h-64 w-full" data-id="element-469" />
        <button className="absolute top-4 left-4 bg-card p-2 rounded-full" onClick={() => navigate(-1)} data-id="element-470">
          <ArrowLeftIcon size={24} className="text-white" data-id="element-471" />
        </button>
      </div>
      <div className="p-6" data-id="element-472">
        <div className="mb-6" data-id="element-473">
          <div className="flex items-start mb-4" data-id="element-474">
            <MapPinIcon size={20} className="text-primary mt-1 mr-3" data-id="element-475" />
            <div data-id="element-476">
              <p className="text-sm text-white text-opacity-70" data-id="element-477">Pickup</p>
              <p className="font-medium" data-id="element-478">
                {currentRide.pickup?.name || 'Current location'}
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-479">
            <MapPinIcon size={20} className="text-primary mt-1 mr-3" data-id="element-480" />
            <div data-id="element-481">
              <p className="text-sm text-white text-opacity-70" data-id="element-482">Dropoff</p>
              <p className="font-medium" data-id="element-483">
                {currentRide.dropoff?.name || 'Destination'}
              </p>
            </div>
          </div>
        </div>
        <div className="mb-6" data-id="element-484">
          <h2 className="text-xl font-semibold mb-4" data-id="element-485">Choose your ride</h2>
          <div data-id="element-486">
            {rideOptions.map(option => <RideCard key={option.id} type={option.type} price={option.price} currency={currency} duration={option.duration} seats={option.seats} selected={selectedRideOption === option.id} onClick={() => handleSelectRide(option.id)} data-id="element-487" />)}
          </div>
        </div>
        <Button onClick={handleContinue} disabled={!selectedRideOption} data-id="element-488">
          Continue
        </Button>
      </div>
    </div>;
};